// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import caculateWidthBy10FontSize from '../caculateFontSize.js'
import { getMaxValue, getMaxLengthValue, isSmallScreenMobile } from '../utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'

const userAllUserBottom = getEchartHeightAndBottomByLocale('usersAllUser').bottom
const userAllUserBottomHor = getEchartHeightAndBottomByLocale('usersAllUser').bottomHor
// const userPercentageBottom = getEchartHeightAndBottomByLocale('usersPercentage').bottom
// const usersPercentageBottomHor = getEchartHeightAndBottomByLocale('usersPercentage').bottomHor

export default function transformer(data = {}, dateToWeek = {}, key = 'users', direction) {
  const { name, period, indicators } = data
  const verticalHeight = isSmallScreenMobile()
    ? 260 // 小屏（竖屏）
    : 240
  const horizontalHeight = isSmallScreenMobile()
    ? 140 // 小屏（横屏）
    : 160
  const chartHeight = direction === 'vertical' ? verticalHeight : horizontalHeight
  return {
    title: name,
    period,
    indicators,
    chartData: [
      parseMergedChartsData(data.chartData, dateToWeek, direction, chartHeight),
      // parsePromoChartsData(data.chartData, dateToWeek, direction, chartHeight),
    ],
    chartHeight,
    chartkey: key,
  }
}

function parseMergedChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  const {
    newCustomerCnt = [], // 新客数
    oldCustomerCnt = [], // 老客数
    dailyNewCustomerRatio, // 新客占比
    dailyOldCustomerRatio, // 老客占比
  } = chartData || {}

  const max = getMaxValue({ newCustomerCnt, oldCustomerCnt })
  const maxRadio = getMaxLengthValue({ count: dailyNewCustomerRatio.concat(dailyOldCustomerRatio) })

  const xAxisData = newCustomerCnt.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right =
    (maxRadio ? caculateWidthBy10FontSize(maxRadio + '%') : caculateWidthBy10FontSize(0, 5)) + 10
  return {
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? userAllUserBottom : userAllUserBottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('FoodB_20250414_EVlU_bloy' /** 新客人数 */),
      vueI18n.t('FoodB_20250414_pQls_dkIZ' /** 老客人数 */),
      vueI18n.t('FoodB_20250414_dobD_hNij' /** 新客占比 */),
      vueI18n.t('FoodB_20250414_BqXP_FPkP' /** 老客占比 */),
    ]),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodB_20250414_QcoH_HIDg' /** 全部用户 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('FoodB_20250414_faVK_FFkd' /** 比例 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right + 8, 0, 0],
        },
        position: 'right',
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_20250414_EVlU_bloy' /** 新客人数 */),
        type: 'bar',
        barWidth: 4,
        color: '#D14F1F',
        stack: 'promotion',
        data: newCustomerCnt.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_20250414_pQls_dkIZ' /** 老客人数 */),
        type: 'bar',
        barWidth: 4,
        color: '#FF8D5C',
        stack: 'promotion',
        data: oldCustomerCnt.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_20250414_dobD_hNij' /** 新客占比 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#41CD16',
        lineStyle: {
          width: 1.5,
        },
        data: dailyNewCustomerRatio.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_20250414_BqXP_FPkP' /** 老客占比 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#FF9A34',
        lineStyle: {
          width: 1.5,
        },
        data: dailyOldCustomerRatio.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

// function parsePromoChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
//   const {
//     dailyNewCustomerRatio, // 新客比
//     dailyOldCustomerRatio, // 老客比
//   } = chartData || {}
//   const max = getMaxValue({ dailyNewCustomerRatio })
//   const maxRadio = getMaxLengthValue({ radio: dailyNewCustomerRatio.concat(dailyOldCustomerRatio) })

//   const xAxisData = dailyNewCustomerRatio.map(item => item.date)
//   const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 16
//   const right =
//     (maxRadio ? caculateWidthBy10FontSize(maxRadio + '%') : caculateWidthBy10FontSize(0, 5)) + 10
//   return {
//     grid: {
//       top: 26,
//       left,
//       right,
//       bottom: direction === 'vertical' ? userPercentageBottom : usersPercentageBottomHor,
//     },
//     tooltip: ToolTipBuilder({
//       position: { left: 0, bottom: chartHeight },
//     }),
//     legend: LegendBuilder([
//       vueI18n.t('FoodB_20250414_dobD_hNij' /** 新客占比 */),
//       vueI18n.t('FoodB_20250414_BqXP_FPkP' /** 老客占比 */),
//     ]),
//     xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
//     yAxis: [
//       YAxisBuilder({
//         name: vueI18n.t('FoodB_20250414_faVK_FFkd' /** 比例 */),
//         nameTextStyle: {
//           color: '#8D9099',
//           fontSize: 10,
//           align: 'left',
//           padding: [0, 0, 0, -left + 8],
//         },
//         axisLabel: {
//           formatter: '{value}%',
//           fontSize: 10,
//           color: '#8D9099',
//         },
//       }),
//     ],
//     series: [
//       {
//         name: vueI18n.t('FoodB_20250414_dobD_hNij' /** 新客占比 */),
//         type: 'line',
//         showSymbol: false,
//         yAxisIndex: 0,
//         color: '#41CD16',
//         lineStyle: {
//           width: 1.5,
//         },
//         data: dailyNewCustomerRatio.map(item => item.value ?? '--'),
//       },
//       {
//         name: vueI18n.t('FoodB_20250414_BqXP_FPkP' /** 老客占比 */),
//         type: 'line',
//         showSymbol: false,
//         yAxisIndex: 0,
//         color: '#FF9A34',
//         lineStyle: {
//           width: 1.5,
//         },
//         data: dailyOldCustomerRatio.map(item => item.value ?? '--'),
//       },
//       WeekendBuilder(xAxisData, dateToWeek),
//     ],
//   }
// }
